import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { select_user_privileges } from 'redux/privileges/selectors';

const usePermissions = () => {
  const privileges = useSelector(select_user_privileges);

  const checkPermission = useCallback(
    (names: string | string[]) => [names].flat().some((name) => !!privileges[name]),
    [privileges],
  );

  return { checkPermission };
};

export default usePermissions;
